"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "attimis": {
    "a5f1136d": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "skipSearch": false
    }],
    "forame": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e73f060d": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "skipSearch": false
    }],
    "porzus": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1215bd42": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "skipSearch": false
    }],
    "racchiuso": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "808484bd": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "skipSearch": false
    }],
    "subit": [{
      "hkey": "d89a4fd6",
      "slug": "attimis",
      "name": "Attimis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;